import MobileDetect from 'aria-viewer/utils/mobileDetect'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { openModal, closeModal, closeAllModals } from 'aria-viewer/modal/modalActions'
import { openRegistrationModal, setRegistrationPageContext, fetchRegistrationAttributes } from './registrationActions'
import ModalTypes from 'aria-viewer/modal/constants/ModalTypes'
import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'

import { CTA_BUTTON_CLICKED, WELCOME_PROMPT, STOP_SKIPPED } from 'aria-viewer/modal/constants/ModalSources'
import RegistrationPageContexts from './RegistrationPageContexts'
import {
    ANALYTICS_REGISTRATION_BTN_CLICKED,
    registrationButtonClicked,
    registrationClosed,
    desktopRegSuccessViewed,
    desktopRegSuccessDoneClicked,
    registrationSubmittedSuccessfully,
} from 'aria-viewer/analytics/analyticActions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { setRegistrationEnabled, setRegistrationWelcomePrompt } from 'aria-viewer/tour/tourActions'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import 'aria-viewer/tour/constants/iscroll.scss'
import 'public/assets/css/tour/registration/registration-all'
import Button from 'aria-viewer/tour/components/buttons/button'
import RegistrationPage2 from './components/registrationPage2'
import WelcomePrompt from './components/welcomePrompt'
import colors from 'aria-viewer/tour/constants/style/colors'
import Validator from 'aria-viewer/utils/validator'
import { AccessibilityController, Registration } from '../legacy'
import MobileRegistrationForm from './containers/mobileRegistrationForm'

export const REGISTER = 'Get Started'
export const FINISHED = 'Register'
export const DONE = 'Done!'

const isPhone = MobileDetect.phone()

const SBase = {
    formModal: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    },
}

const S = {
    desktopFormModal: isVisible => {
        return {
            ...SBase.formModal,
            background: 'none',
            display: isVisible ? 'block' : 'none',
            transform: 'translate3d(0,0,2px)',
            zIndex: 2010,
        }
    },
    mobileFormModal: isVisible => {
        return {
            ...SBase.formModal,
            display: isVisible ? 'block' : 'none',
        }
    },
    desktopForm: {
        fontFamily: '"Circular Std Book, Helvetica", Arial, sans-serif, Icons',
        color: styleguide.colors.grey_10,
    },
    formButton: Object.assign({}, styleguide.button_orange, {
        display: `block`,
        margin: `0 auto`,
        width: 262,
        color: colors.black,
        textAlign: 'center',
        padding: '4% 0',
        zIndex: '2',
        textTransform: 'uppercase',
        label: {
            fontSize: 16,
            whiteSpace: 'nowrap',
        },
    }),
    mobileFormWrapper: {
        position: 'absolute',
        top: '10px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'calc(100% - 20px)',
        maxWidth: '440px',
        height: 'calc(100% - 45px)',
        background: colors.white,
        borderRadius: '4px',
    },
    reactIScroll: {
        height: 'calc(100% - 30px)',
        overflow: 'hidden',
    },
    registrationForm: {
        position: 'relative',
        width: 'calc(100% - 40px)',
        padding: '30px 20px 15px',
        borderRadius: '4px',
        zIndex: '1',
    },
    registrationFormTitle: {
        width: '100%',
        background: colors.white,
        textAlign: 'center',
        fontWeight: styleguide.fonts.weight.bold,
        fontSize: 24,
    },
}

const successModalPrompt = ({ stopIndex, emailEnabled }) => {
    if (isPhone) {
        return {
            id: ANALYTICS_REGISTRATION_BTN_CLICKED,
            icon: {
                iconName: 'registrationCheck',
                iconStyle: {
                    height: '8.75em',
                },
            },
            body: 'Thanks for your submission.',
            bodyStyle: styleguide.modals.registrationBody,
            containerStyle: { background: 'rgba(0,0,0,.8)' },
            contentStyle: { overflow: 'visible' },
            formClickAction: 'closeModal',
        }
    } else {
        return {
            id: ANALYTICS_REGISTRATION_BTN_CLICKED,
            title: 'You Registered Successfully!',
            body: emailEnabled ? "You'll receive an email shortly." : 'Thank you for submitting your information.',
            submit: {
                label: 'OK',
                action: 'closeModal',
            },
            containerStyle: {
                background: 'rgba(0,0,0,.8)',
            },
            contentStyle: {
                overflow: 'visible',
            },
        }
    }
}

class RegistrationWrapper extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            registration: null,
            submitIndex: 0,
            iScrollOptions: {
                preventDefault: false, //set this to false because it was interfering with native ios behaviour
                disableTouch: false,
            },
            fields: {
                firstname: {
                    id: 'firstname',
                    type: 'text',
                    placeholder: 'First Name*',
                    validations: [
                        {
                            validator: 'isRequired',
                        },
                    ],
                    style: {
                        width: '45%',
                        verticalAlign: 'top',
                    },
                },
                lastname: {
                    id: 'lastname',
                    type: 'text',
                    placeholder: 'Last Name*',
                    validations: [
                        {
                            validator: 'isRequired',
                        },
                    ],
                    style: {
                        width: '45%',
                        marginLeft: '10%',
                        verticalAlign: 'top',
                    },
                },
                email: {
                    id: 'email',
                    type: 'text',
                    placeholder: 'Email*',
                    validations: [
                        {
                            validator: 'isRequired',
                        },
                        {
                            validator: 'isEmail',
                        },
                    ],
                    style: {
                        verticalAlign: 'top',
                        marginTop: '10px',
                    },
                },
            },
        }

        this.btnLabels = {
            register: REGISTER,
            finished: FINISHED,
            done: DONE,
        }

        this.registrationPage1Loaded = this.registrationPageLoaded.bind(this, RegistrationPageContexts.DESKTOP_LANDING)
        this.registrationPage2Loaded = this.registrationPageLoaded.bind(this, RegistrationPageContexts.AFTER_LANDING)
        this.regiIscroll = React.createRef()
    }

    static contextTypes = {
        width: PropTypes.number,
        height: PropTypes.number,
    }

    componentDidMount() {
        this.init(this.props)
    }
    componentWillReceiveProps(props) {
        this.init(props)
    }

    closeRegistration = () => {
        const {
            closeModal,
            registrationClosed,
            regWelcomePrompt,
            setRegistrationWelcomePrompt,
            closeAllModals,
            registrationPageContext,
        } = this.props

        //Clear my fields
        const { fields } = this.state
        if ([RegistrationPageContexts.DESKTOP_LANDING].includes(registrationPageContext)) {
            this.setState({
                fields: Object.keys(fields).reduce((formFields, key) => {
                    const { id } = fields[key]

                    return {
                        ...formFields,
                        [id]: Object.assign({}, fields[key], {
                            value: '',
                            error: null,
                        }),
                    }
                }, {}),
            })
        }

        // Analytics action
        registrationClosed(registrationPageContext, fields)

        if (regWelcomePrompt) setRegistrationWelcomePrompt(false)

        if (isPhone) {
            closeAllModals()
        } else {
            closeModal()
        }
    }

    updateField = item => {
        if (item) {
            this.setState({
                fields: Object.assign({}, this.state.fields, {
                    [item.key]: Object.assign({}, this.state.fields[item.key], { value: item.value }),
                }),
            })
        }
        this.resizeIScroll()
    }

    init = ({ registrationModalsOpen, regWelcomePrompt, activeRegistrationModalSource, registrationPageContext }) => {
        if (
            registrationModalsOpen[ModalContentTypes.WELCOME_REGISTRATION] &&
            regWelcomePrompt &&
            registrationPageContext != RegistrationPageContexts.MOBILE_LANDING
        ) {
            setRegistrationPageContext(RegistrationPageContexts.MOBILE_LANDING)
            this.registrationPageLoaded(RegistrationPageContexts.MOBILE_LANDING)
        } else if (!regWelcomePrompt && Object.keys(registrationModalsOpen).length > 0) {
            if (activeRegistrationModalSource == CTA_BUTTON_CLICKED) {
                setRegistrationPageContext(RegistrationPageContexts.AFTER_LANDING)
            } else {
                setRegistrationPageContext(RegistrationPageContexts.DESKTOP_LANDING)
            }
        }
    }

    startRegistration = (startPage = RegistrationPageContexts.DESKTOP_LANDING, initBy = WELCOME_PROMPT) => {
        this.props.setRegistrationPageContext(startPage)
        this.props.closeModal()
        this.props.openRegistrationModal(initBy)
    }

    handleChange = (item, event) => {
        const { fields } = this.state
        fields[item.id] = Object.assign({}, fields[item.id], { value: event.target.value })
        this.setState({ fields })

        if (this.state.iScrollOptions.disableTouch) {
            this.setState({
                iScrollOptions: {
                    preventDefault: true,
                    disableTouch: false,
                },
            })
        }
    }

    showMobileFormFull = () => {
        this.startRegistration(RegistrationPageContexts.AFTER_LANDING, WELCOME_PROMPT)
    }

    resizeIScroll = () => {
        const regiIscroll = this.regiIscroll.current
        if (regiIscroll) {
            //the delay is to wait for the mobile keyboard to pop up
            setTimeout(() => {
                regiIscroll.getIScroll() && regiIscroll.getIScroll().refresh()
            }, parseInt(styleguide.delay.normal))
        }
    }
    /**
     * @param errors an array of dom elements that contain errors
     * 		  so we can scroll the first one into view
     */
    handleFieldError = errors => {
        if (errors.length) {
            this.handleFocusField(errors[0])
        }
    }
    handleFocusField = field => {
        const regiIscroll = this.regiIscroll.current
        this.resizeIScroll()
        const focusedElement = document.getElementById(`registration-${field}`)

        if (regiIscroll && focusedElement && !MobileDetect.is('iOS')) {
            //dont run this if it's iOS
            setTimeout(
                () => {
                    regiIscroll.getIScroll().scrollToElement(focusedElement, null, null, true)
                },
                window.innerHeight <= 350 ? 0 : 550
            ) //if the keyboard is already present, dont set timeout
        }

        // handles mobile scroll to error
        // error fields come in as elements for some reason, not strings
        if (isPhone && regiIscroll && field.className && field.className.includes('error')) {
            regiIscroll.getIScroll().scrollToElement(field, null, null, true)
        }

        //if field focused is school, disable touch
        if (field === 'school') {
            this.setState({
                iScrollOptions: {
                    disableTouch: true,
                },
            })
        } else if (field === 'visitortype' || this.state.iScrollOptions.disableTouch) {
            //need to set preventdefault to true when it's visitortype because
            //it was causing legacy bug
            //only set if options have been changed
            this.setState({
                iScrollOptions: {
                    preventDefault: true,
                    disableTouch: false,
                },
            })
        } else {
            this.handleResumePageScroll()
        }
    }

    handleResumePageScroll = () => {
        // currently just used for auto complete
        this.setState({
            iScrollOptions: {
                preventDefault: false,
                disableTouch: false,
            },
        })
    }

    setRegistrationForm = registration => {
        this.setState({ registration })
    }
    submitRegistrationForm = () => {
        const { registration } = this.state

        if (registration && registration._form && registration._form.$submitBtn) {
            //this loop will fix the bug where
            //when you hit submit, it doesnt have any value yet
            for (let fieldid in registration._form._fields) {
                let fieldProps = registration._form._fields[fieldid]

                //if it has input and is relevant, force a change event
                if (fieldProps.isRelevant() && fieldProps.$input) {
                    fieldProps.$input.change()
                }
            }

            registration.submitForm(registration._form, isSubmitSuccessful => {
                if (isSubmitSuccessful) this.props.registrationSubmittedSuccessfully()
            })
        }
    }
    showFormButton = () => {
        const { activeRegistrationModalSource, registrationPageContext } = this.props
        let label

        if (registrationPageContext == RegistrationPageContexts.DESKTOP_LANDING) {
            label = this.btnLabels.register
        } else {
            if (activeRegistrationModalSource == WELCOME_PROMPT) {
                label = this.btnLabels.register
            } else {
                label = this.btnLabels.done
            }
        }

        const action =
            registrationPageContext == RegistrationPageContexts.DESKTOP_LANDING
                ? this.checkFields
                : this.submitRegistrationForm
        return (
            <Button id={label} onClick={action} theme={S.formButton}>
                {label}
            </Button>
        )
    }

    checkFields = () => {
        const { fields, submitIndex } = this.state
        const regiIscroll = this.regiIscroll.current
        let hasErrors = false
        const formFields = Object.keys(fields).reduce((formFields, key) => {
            const { id, validations = [], value = '' } = fields[key]
            let error = Validator.checkErrors(value.trim(), validations)
            hasErrors = hasErrors || error

            return {
                ...formFields,
                [id]: Object.assign({}, fields[key], {
                    error,
                }),
            }
        }, {})

        if (!hasErrors) {
            this.props.registrationButtonClicked(this.btnLabels.register, { _fields: formFields })
            if (regiIscroll) {
                regiIscroll.getIScroll().scrollTo(0, 0)
            }
        }

        this.setState({
            fields: formFields,
            submitIndex: submitIndex + 1,
        })

        if (hasErrors) {
            // if there were errors, change the initial view to an after
            // landing view
            setRegistrationPageContext(RegistrationPageContexts.AFTER_LANDING)
        }
    }

    registrationSuccess = ({ emailEnabled }) => {
        const {
            closeAllModals,
            openModal,
            setRegistrationEnabled,
            fetchRegistrationAttributes,
            stopIndex,
            setRegistrationWelcomePrompt,
            desktopRegSuccessDoneClicked,
            location: { loc_id, owner_id },
        } = this.props

        desktopRegSuccessDoneClicked()

        setRegistrationEnabled(false)
        fetchRegistrationAttributes(owner_id, loc_id)

        closeAllModals()

        if (isPhone) {
            openModal(ModalTypes.ALERT, {
                type: 'modal',
                ...successModalPrompt({ stopIndex, emailEnabled }),
            })

            setRegistrationWelcomePrompt(false)

            //this is to hide the success
            //message after 2 seconds
            setTimeout(() => {
                closeAllModals()
            }, 2000)
        }
    }

    registrationSubmitted = ({ fields }) => {
        const { registrationButtonClicked, desktopRegSuccessViewed } = this.props

        const _fields = Object.keys(fields).reduce(
            (obj, key) => ({
                ...obj,
                [key]: fields[key].value,
            }),
            {}
        )

        registrationButtonClicked(this.btnLabels.finished, {
            _fields,
        })

        desktopRegSuccessViewed()
    }

    registrationPageLoaded = registrationPageContext => {
        this.props.setRegistrationPageContext(registrationPageContext)
    }

    getTagLine = () => {
        const { activeRegistrationModalSource } = this.props

        switch (activeRegistrationModalSource) {
            case WELCOME_PROMPT:
                return 'Tell us more about yourself to get started.'
            case CTA_BUTTON_CLICKED:
                return 'Tell us more about yourself to receive ' + 'information and customize your experience.'
            case STOP_SKIPPED:
                return 'Tell us more about yourself to ' + 'continue the experience.'
        }
    }

    componentDidUpdate() {
        this.resizeIScroll()
        /* force proper focus/accesibility */
        const areRegistrationModalsOpen = Object.keys(this.props.registrationModalsOpen).length > 0
        if (areRegistrationModalsOpen) {
            AccessibilityController.modalShown('.registrationForm_modal')
        } else {
            AccessibilityController.modalDismissed('.registrationForm_modal')
        }
    }

    render() {
        const {
            isRegistrationEnabled,
            registrationModalsOpen,
            desktop = false,
            registrationPageContext,
            isCTAPromptOpen,
            location,
            activeRegistrationModalSource,
            registrationForm,
            width,
            height,
        } = this.props

        const areRegistrationModalsOpen = Object.keys(registrationModalsOpen).length > 0

        const { fields, registration, submitIndex } = this.state,
            isWelcomePage = registrationPageContext == RegistrationPageContexts.MOBILE_LANDING

        let title
        if (registrationPageContext == RegistrationPageContexts.DESKTOP_LANDING) {
            title = 'Enter your Info to Skip a Stop'
        } else {
            switch (activeRegistrationModalSource) {
                case WELCOME_PROMPT:
                    title = 'Get Started!'
                    break
                case CTA_BUTTON_CLICKED:
                    title = ''
                    break
                default:
                    title = 'Almost Done!'
                    break
            }
        }

        const scrollOptions = {
            tap: true,
            mouseWheel: true,
            scrollbars: 'custom',
            fadeScrollbars: true,
            disablePointer: true,
            disableTouch: this.state.iScrollOptions.disableTouch,
            disableMouse: true,
            scrollY: true,
            preventDefault: this.state.iScrollOptions.preventDefault,
        }

        return isRegistrationEnabled ? (
            <div>
                <div
                    className="registrationForm_modal"
                    aria-hidden={areRegistrationModalsOpen ? 'false' : 'true'}
                    style={
                        desktop
                            ? S.desktopFormModal(areRegistrationModalsOpen, isCTAPromptOpen)
                            : S.mobileFormModal(areRegistrationModalsOpen, isCTAPromptOpen)
                    }
                >
                    {isWelcomePage && (
                        <WelcomePrompt
                            formClick={desktop ? this.startRegistration : this.showMobileFormFull}
                            desktop={desktop}
                            {...this.props}
                        />
                    )}
                    {!isWelcomePage && desktop && (
                        <RegistrationPage2
                            ref={'registrationForm2'}
                            style={S.desktopForm}
                            mobile={false}
                            tablet={MobileDetect.tablet() || false}
                            formClass={Registration.prototype.themes.material_ui}
                            experienceName={location.name}
                            registrationForm={registration}
                            bindRegistration={this.setRegistrationForm}
                            fieldsUpdated={this.updateField}
                            handleFieldError={this.handleFieldError}
                            onLoad={this.registrationPage2Loaded}
                            onRegistrationSuccess={this.registrationSuccess}
                            onRegistrationSubmitted={this.registrationSubmitted}
                            onClose={this.closeRegistration}
                        />
                    )}
                </div>
                <MobileRegistrationForm
                    handleFocusField={this.handleFocusField}
                    handleChange={this.handleChange}
                    activeRegistrationModalSource={activeRegistrationModalSource}
                    registrationForm={registrationForm}
                    registrationPageContext={registrationPageContext}
                    width={width}
                    height={height}
                    location={location}
                    fields={fields}
                    registration={registration}
                    submitIndex={submitIndex}
                    title={title}
                    scrollOptions={scrollOptions}
                    isRegistrationPrompt={this.isRegistrationPrompt}
                    registrationPage1Loaded={this.registrationPage1Loaded}
                    setRegistrationForm={this.setRegistrationForm}
                    updateField={this.updateField}
                    handleFieldError={this.handleFieldError}
                    handleResumePageScroll={this.handleResumePageScroll}
                    registrationPage2Loaded={this.registrationPage2Loaded}
                    registrationSuccess={this.registrationSuccess}
                    registrationSubmitted={this.registrationSubmitted}
                    isPhone={isPhone}
                    closeRegistration={this.closeRegistration}
                    showFormButton={this.showFormButton()}
                    getTagLine={this.getTagLine()}
                    ref={this.regiIscroll}
                    areRegistrationModalsOpen={areRegistrationModalsOpen}
                    isWelcomePage={isWelcomePage}
                    desktop={desktop}
                />
            </div>
        ) : (
            isPhone && <WelcomePrompt width={this.context.width} height={this.context.height} />
        )
    }
}

export default connect(
    mapSelectorsToProps([
        'location',
        'isRegistrationEnabled',
        'regWelcomePrompt',
        'registrationModalsOpen',
        'registrationForm',
        'stopIndex',
        'activeRegistrationModalSource',
        'registrationPageContext',
        'isCTAPromptOpen',
    ]),
    {
        openRegistrationModal,
        openModal,
        closeModal,
        closeAllModals,
        registrationButtonClicked,
        registrationClosed,
        setRegistrationEnabled,
        fetchRegistrationAttributes,
        setRegistrationWelcomePrompt,
        desktopRegSuccessViewed,
        desktopRegSuccessDoneClicked,
        registrationSubmittedSuccessfully,
        setRegistrationPageContext,
    }
)(RegistrationWrapper)
